import React from "react";
import { Search, ArrowRight, Home, Newspaper, FileText } from "lucide-react";
function Newssidebar({ localBuzz }) {
  let newsItems = [];
  newsItems = localBuzz.map((article, index) => {
    const colors = ["#7b189f", "#000000", "#0ca3a5"];
    const icons = [Home, Newspaper, FileText];

    return {
      ...article,
      color: colors[index % 3],
      icon: icons[index % 3]
    };
  });

  return (
    <div>
      <div className="w-full xl:w-96 border-t xl:border-t-0 xl:border-l border-[#F5E8EA] p-4 sm:p-5 lg:p-6 bg-white">
        {/* For 900-1200px range, make the sidebar horizontal with grid */}
        <div className="hidden md:block lg:hidden xl:hidden">
          <div className="flex flex-col">
            {/* Search Bar */}
            <div className="relative mb-5 max-w-md mx-auto w-full">
              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                <Search className="h-4 w-4 text-[#a8a5ad]" />
              </div>
              <input
                type="text"
                placeholder="nearby Indian restaurant, Roommates etc..."
                className="pl-10 pr-4 py-2 h-10 bg-[#f5f3f5] border-none text-sm rounded-full w-full focus:outline-none focus:ring-1 focus:ring-[#7b189f]"
              />
            </div>

            {/* Top Local Buzz - Horizontal layout for 900-1200px */}
            <div>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg sm:text-xl font-bold text-[#232123]">
                  Top Local Buzz
                </h2>
                <button className="text-[#7b189f] text-sm font-medium flex items-center gap-1 hover:underline">
                  Explore More <ArrowRight className="h-3 w-3" />
                </button>
              </div>

              {/* News Items in horizontal grid for 900-1200px */}
              <div className="grid grid-cols-3 gap-4 sm:gap-5">
                {newsItems.slice(0, 6).map(item => (
                  <div
                    onClick={() => window.open(item.sourceurl, "_blank")}
                    key={item.id}
                    className="cursor-pointer group"
                  >
                    <div className="flex items-center gap-2 mb-1">
                      <div
                        className="text-white p-1 rounded flex-shrink-0"
                        style={{ backgroundColor: item.color }}
                      >
                        <item.icon size={14} />
                      </div>
                      <span className="text-xs sm:text-sm text-[#a8a5ad] truncate max-w-full block">
                        {item.source}
                      </span>
                    </div>
                    <h3 className="text-[#232123] font-medium text-xs sm:text-sm group-hover:text-[#7b189f] transition-colors">
                      {item.subject}
                    </h3>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Special layout for 800-900px range - Vertical list */}
        <div className="hidden sm:block md:hidden lg:hidden xl:hidden">
          <div className="flex flex-col">
            {/* Search Bar */}
            <div className="relative mb-5">
              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                <Search className="h-4 w-4 text-[#a8a5ad]" />
              </div>
              <input
                type="text"
                placeholder="nearby Indian restaurant, Roommates etc..."
                className="pl-10 pr-4 py-2 h-10 bg-[#f5f3f5] border-none text-sm rounded-full w-full focus:outline-none focus:ring-1 focus:ring-[#7b189f]"
              />
            </div>

            {/* Top Local Buzz - Vertical layout for 800-900px */}
            <div>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-bold text-[#232123]">
                  Top Local Buzz
                </h2>
                <button className="text-[#7b189f] text-sm font-medium flex items-center gap-1 hover:underline">
                  Explore More <ArrowRight className="h-3 w-3" />
                </button>
              </div>

              {/* News Items in vertical list for 800-900px */}
              <div className="space-y-4">
                {newsItems.slice(0, 6).map(item => (
                  <div
                    onClick={() => window.open(item.sourceurl, "_blank")}
                    key={item.id}
                    className="cursor-pointer group"
                  >
                    <div className="flex items-center gap-2 mb-1">
                      <div
                        className="text-white p-1 rounded flex-shrink-0"
                        style={{ backgroundColor: item.color }}
                      >
                        <item.icon size={14} />
                      </div>
                      <span className="text-xs sm:text-sm text-[#a8a5ad] truncate max-w-full block">
                        {item.source}
                      </span>
                    </div>
                    <h3 className="text-[#232123] font-medium text-xs sm:text-sm group-hover:text-[#7b189f] transition-colors">
                      {item.subject}
                    </h3>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Regular vertical sidebar for mobile and xl screens */}
        <div className="sm:hidden lg:block xl:block">
          {/* Top Local Buzz */}
          <div>
            <div className="flex justify-between items-center mb-4 sm:mb-5">
              <h2 className="text-lg sm:text-xl font-bold text-[#232123] font-fraunces">
                Top Local Buzz
              </h2>
              {/* <button className="text-[#7b189f] text-xs sm:text-sm font-medium flex items-center gap-1 hover:underline">
                Explore More <ArrowRight className="h-3 w-3" />
              </button> */}
            </div>

            {/* News Items List */}
            <div className="space-y-0">
              {/* Group news items in sets of three */}
              {Array.from({ length: Math.ceil(newsItems.length / 3) }).map(
                (_, groupIndex) => (
                  <div
                    key={groupIndex}
                    className={`py-4 sm:py-5 ${
                      groupIndex < Math.ceil(newsItems.length / 3) - 1
                        ? "border-b border-[#F5E8EA]"
                        : ""
                    }`}
                  >
                    <div className="space-y-3 sm:space-y-4">
                      {newsItems
                        .slice(groupIndex * 3, (groupIndex + 1) * 3)
                        .map(item => (
                          <div
                            onClick={() =>
                              window.open(item.sourceurl, "_blank")
                            }
                            key={item.id}
                            className="cursor-pointer group"
                          >
                            <div className="flex items-center gap-2 mb-1">
                              <div
                                className="text-white p-1 rounded flex-shrink-0"
                                style={{ backgroundColor: item.color }}
                              >
                                <item.icon size={14} />
                              </div>
                              <span className="text-xs sm:text-sm text-[#a8a5ad] truncate max-w-full block">
                                {item.source}
                              </span>
                            </div>
                            <h3 className="text-[#232123] font-medium text-xs sm:text-sm group-hover:text-[#7b189f] transition-colors">
                              {item.subject}
                            </h3>
                          </div>
                        ))}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Newssidebar;
